// returns whether a node is a declaration
export default (node) => node && node.type === 'decl';
